import {
   AnnulledPrescription,
   calculateNewIssuedToLocalDate,
   changeIssuedToDateFromPastToTodayOnly,
   findReimbursementByType,
   isIssuedForMoreThanMonth,
   RecipientCategory,
   selectAdditionalRequirementsTypes,
   ValidatedPrescription,
} from '~libs.shared.prescription';

import { SentMagistralDrugPrescription } from './SentMagistralDrugPrescriptionItem.types';

export const mapPrescriptionToSentMagistralPrescription = (
   prescription: AnnulledPrescription | ValidatedPrescription,
   recipientCategory: RecipientCategory | undefined
): SentMagistralDrugPrescription => {
   const issuedForYear = isIssuedForMoreThanMonth(prescription.issuedFrom, prescription.issuedTo);
   const issuedFrom = changeIssuedToDateFromPastToTodayOnly(prescription.issuedFrom);
   const issuedTo = calculateNewIssuedToLocalDate(prescription.issuedFrom, issuedForYear)!;

   return {
      id: prescription.id.toString(),
      annulled: prescription.annulled,
      medicinePrescription: prescription.medicinePrescription,
      type: 'magistralDrug',
      reimbursement: findReimbursementByType(
         prescription.reimbursementType ?? 'FULL',
         prescription.medicinePrescription.reimbursements
      ),
      dosage: prescription.dosage!,
      quantity: prescription.quantity,
      issuedFrom: issuedFrom,
      issuedTo: issuedTo,
      additionalEntitlementTypes: prescription.additionalEntitlementTypes,
      additionalRequirementTypes: selectAdditionalRequirementsTypes({
         cito: false, // TODO: DREGAB-3969 Waiting for implementation - cito flag
         issuedForYear: issuedForYear,
         substituteForbidden: prescription.substituteForbidden,
      }),
      annullable: prescription.annullable,
      prescriptionCategory: recipientCategory,
   };
};
